
import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';
import apiUrl from '../../environment/Api';
import { toast } from 'react-toastify';
import { Link } from "react-router-dom";


import Select from "react-select";
import styled from "styled-components";
import {
    useTable,
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
} from "react-table";
import { createPortal } from "react-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import ActionsDropdown from '../ActionsDropdown';



const TableContainer = styled.div`
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  // Apply striped rows styling
  tr:nth-child(odd) {
    background-color: #f2f2f2; /* Light gray for even rows */
  }

  tr:nth-child(even) {
    background-color: #ffffff; /* White for odd rows */
  }
`;

const Th = styled.th`
  padding: 10px;
  background-color: #fff;
  text-align: left;
  cursor: pointer;
  position: relative;
`;

const Td = styled.td`
  padding: 10px;
  // border: 1px solid #ddd;
`;

function GlobalFilter({ globalFilter, setGlobalFilter }) {
    return (
        <div style={{ marginBottom: "10px" }}>
            <input
                value={globalFilter || ""}
                onChange={(e) => setGlobalFilter(e.target.value)}
                placeholder="Search all columns..."
                style={{
                    padding: "5px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    width: "100%",
                }}
            />
        </div>
    );
}
// Default Column Filter (Icon-based)
const DefaultColumnFilter = ({
    column: { filterValue, setFilter, preFilteredRows, id },
}) => {
    const [isActive, setIsActive] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const options = useMemo(() => {
        const uniqueValues = Array.from(
            new Set(preFilteredRows.map((row) => row.values[id]))
        ).map((value) => ({ label: value, value }));
        return [{ label: "All", value: "" }, ...uniqueValues];
    }, [id, preFilteredRows]);

    // Handle icon click
    const handleIconClick = () => {
        setIsActive(!isActive);
    };

    const handleMultiSelectChange = (selectedOptions) => {
        const values = selectedOptions
            ? selectedOptions.map((option) => option.value)
            : [];
        setFilter(values.length > 0 ? values : undefined);
    };

    return (
        <div style={{ alignItems: "center" }}>
            <div>
                <i
                    className="fa-solid fa-ellipsis-vertical"
                    onClick={handleIconClick}
                    style={{
                        cursor: "pointer",
                        fontSize: "20px",
                        color: "#AC0000",
                    }}
                ></i>
            </div>
            <div>
                {isActive &&
                    createPortal(
                        <div
                            style={{
                                position: "fixed",
                                zIndex: 9999,
                                left: "50%",
                                top: "50%",
                                width: "30%",
                                transform: "translate(-50%, -50%)",
                            }}
                        >
                            <div
                                style={{
                                    position: "relative",
                                    background: "white",
                                    padding: "20px",
                                    borderRadius: "8px",
                                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                                    backgroundColor: "#A70000",
                                }}
                            >
                                <Select
                                    options={options}
                                    isMulti
                                    value={options.filter((option) =>
                                        filterValue?.includes(option.value)
                                    )}
                                    onChange={handleMultiSelectChange}
                                    isClearable
                                    isSearchable
                                    placeholder={`Filter ${id}`}
                                    styles={{
                                        menu: (provided) => ({
                                            ...provided,
                                            zIndex: 9999,
                                        }),
                                    }}
                                />
                                <button
                                    style={{
                                        marginTop: "10px",
                                        marginLeft: "150px",
                                        padding: "5px 10px",
                                        background: "#007bff",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setIsActive(false)} // Close the popup
                                >
                                    Close
                                </button>
                            </div>
                        </div>,
                        document.body
                    )}
            </div>
        </div>
    );
};


function Recruiting_partner() {

    const [responseData, setResponseData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isUpdateshowModal, setUpdateShowModal] = useState(false);
    const [branch, setbranch] = useState([]);

    const [role_id, setroleid] = useState('');
    const [previllages, setprevillages] = useState({})


    const [addData, setAddData] = useState({
        idlocal: "",
        branch_id: '',
        category: '',
        FacultyName: '',
        Designation: '',
        official_email: '',
        website: '',
        location: '',
        remark: '',
        staffid_name: '',
        status: '',


    });



    const [updateData, setUpdateData] = useState({

        idlocal: "",
        branch_id: '',
        category: '',
        FacultyName: '',
        Designation: '',
        official_email: '',
        website: '',
        location: '',
        remark: '',
        staffid_name: '',
        status: '',
    });

    useEffect(() => {
        fetchData();
        fetchDataed();
        getprevillages();
        gettoken();
        window.scrollTo(0, 0);
    }, []);

    // useEffect(() => {
    //     window.scrollTo(0, 0);
    // }, []);

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl + "/recruting_partner", {
                params: { data: localStorage.getItem("branch_id") },
            });
            console.log("Response from server:", response.data);
            setResponseData(response.data.reverse());
            if (response && response.status === 200) {
                setTimeout(() => {
                    setLoading(false);
                }, 300);
            }

        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };


    const fetchDataed = async () => {
        try {
            const response = await axios.get(apiUrl + "/Branch");
            console.log("Response from server:", response.data);
            setbranch(response.data);
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };




    const gettoken = async () => {
        const token = localStorage.getItem('token');

        try {
            const response = await axios.post(apiUrl + "/get_detail", { "token": token });
            console.log("token detail from server:", response.data);


            setroleid(response.data.detail.rolename);

            localStorage.setItem('role_id', response.data.detail.rolename);

            const id = response.data.detail.rolename

            if (id) {

            }

        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    }

    const getprevillages = () => {
        const username = JSON.parse(localStorage.getItem("user_previllages"));
        console.log("tyhe username get by local stroage : ", username.modules);
        const total_previlages = username.modules;
        const new_enquiry = total_previlages.find((item) => item.name == "Recruiting partner")
        console.log("the new_enquiry is : ", new_enquiry.actions);

        setprevillages(new_enquiry.actions)
    }





    // const handleNewButtonClick = () => {
    //     if (previllages.add || previllages.all) {
    //     setShowModal(true);
    // }else{
    //     toast.error("You don't have the permission to add");
    // }
    // }

    const handlesubmit = async (e) => {
        e.preventDefault();


        try {
            setLoading(true);
            const formData = {

                staffname: idlocal,
                // branch_id: addData.branch_id,
                name: addData.name,
                asset_prefix: addData.asset_prefix,
                branch_id: addData.branch_id,
                category: addData.category,
                FacultyName: addData.FacultyName,
                Designation: addData.Designation,
                official_email: addData.official_email,
                website: addData.website,
                location: addData.location,
                remark: addData.remark,
                staffid_name: addData.staffid_name,
                status: addData.status,
            }
            const response = await axios.post(apiUrl + "/recruting_partner", formData);
            console.log("Updated:", response);
            setShowModal(false);
            toast.success("added successfully!");
            setAddData({
                staffname: idlocal,
                branch_id: '',
                category: '',
                FacultyName: '',
                Designation: '',
                official_email: '',
                website: '',
                location: '',
                remark: '',
                staffid_name: '',
                status: '',
            });

            fetchData();
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        } catch (error) {
            console.error("Error updating data:", error.message);
        }
    };


    const [updateid, setUpdateId] = useState("");

    const handleUpdate = (_id, data) => {
        if (previllages.edit || previllages.all) {
            setUpdateId(_id);
            console.log("the data to update", data);
            setUpdateShowModal(true);
            setUpdateData({
                staffname: idlocal,
                branch_id: data.branch_id?._id || "", // Add null check here
                category: data.category || "",
                FacultyName: data.FacultyName || "",
                Designation: data.Designation || "",
                official_email: data.official_email || "",
                website: data.website || "",
                location: data.location || "",
                remark: data.remark || "",
                staffid_name: data.staffid_name || "",
                status: data.status || "",
            });
        } else {
            toast.error("You don't have the permission to update");
        }
    };


    const handleupdatesubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const formData = {

                staffname: idlocal,
                // name: updateData.name,
                // asset_prefix: updateData.asset_prefix,
                branch_id: updateData.branch_id,
                category: updateData.category,
                FacultyName: updateData.FacultyName,
                Designation: updateData.Designation,
                official_email: updateData.official_email,
                website: updateData.website,
                location: updateData.location,
                remark: updateData.remark,
                staffid_name: updateData.staffid_name,
                status: updateData.status,
            }
            console.log("the update submit data", formData)
            const response = await axios.put(apiUrl + `/recruting_partner/${updateid}`, formData)
            console.log("response for update", response)
            setUpdateShowModal(false)
            toast.success("Update successfully!");
            setTimeout(() => {
                setLoading(false);
            }, 1000);
            fetchData();
        }
        catch (error) {
            console.error("Error updating data:", error.message);
        }

    }

    const [deleteShowModalss, setDeleteShowModalss] = useState(false);
    const handleCloseModal = () => {
        setDeleteShowModalss(false);
    }



    const [getdeleteid, setdeleteid] = useState('')

    const [getdeletename, setdeletename] = useState('')
    const handleOpenModal = (_id, category) => {
        if (previllages.all || previllages.delete) {
            console.log(" the id", _id)
            console.log(" the name", category)
            setdeleteid(_id);
            setdeletename(category);
            setDeleteShowModalss(true);
        } else {
            toast.error("You don't have the permission to delete");
        }
    }

    const handleDelete = async (id) => {
        try {
            setLoading(true);
            const response = await axios.delete(apiUrl + `/recruting_partner/${getdeleteid}`)
            console.log("delete data ", response)
            if (response.status === 200) {
                setDeleteShowModalss(false);
                fetchData();
                toast.error("Delete successfully!");
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
            }

        }
        catch (error) {
            console.error("Error updating data:", error.message);
        }

    };

    const [idlocal, setlocalid] = useState([]);

    useEffect(() => {
        fetchData();
        const id_local = localStorage.getItem("username");
        setlocalid(id_local);
    }, []);






    // the pagination ---------------------------------------------------------------------
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = responseData.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Search
    const filtered = currentItems.filter((item) =>
        Object.values(item).some(
            (value) =>
                typeof value === "string" &&
                value.toLowerCase().includes(searchQuery.toLowerCase()) ||
                (typeof value === "number" && value.toString().includes(searchQuery))
        )
    );

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1);
    };

    const totalPages = Math.ceil(responseData.length / itemsPerPage);

    const goToNextPage = () => {
        setCurrentPage((prevPage) =>
            prevPage === totalPages ? prevPage : prevPage + 1
        );
    };

    const goToPrevPage = () => {
        setCurrentPage((prevPage) => (prevPage === 1 ? prevPage : prevPage - 1));
    };
    // the pagination  end ---------------------------------------------------------------------


    const createPagination = () => {
        let liTag = [];
        let beforePage = currentPage - 1;
        let afterPage = currentPage + 1;
        let active;

        if (currentPage > 1) {
            liTag.push(
                <li className="page-item" key="prev">
                    <button
                        className="page-link"
                        onClick={() => paginate(currentPage - 1)}
                    >
                        <FaAngleLeft /> Prev
                    </button>
                </li>
            );
        }

        if (currentPage > 2) {
            liTag.push(
                <li className="page-item" key="first" onClick={() => paginate(1)}>
                    <button className="page-link">1</button>
                </li>
            );
            if (currentPage > 3) {
                liTag.push(
                    <li className="page-item disabled" key="dots1">
                        <span className="page-link">...</span>
                    </li>
                );
            }
        }

        if (currentPage === totalPages) {
            beforePage -= 2;
        } else if (currentPage === totalPages - 1) {
            beforePage -= 1;
        }

        if (currentPage === 1) {
            afterPage += 2;
        } else if (currentPage === 2) {
            afterPage += 1;
        }

        for (let plength = beforePage; plength <= afterPage; plength++) {
            if (plength > totalPages || plength <= 0) continue;
            active = currentPage === plength ? "active" : "";
            liTag.push(
                <li
                    className={`page-item ${active}`}
                    key={plength}
                    onClick={() => paginate(plength)}
                >
                    <button className="page-link">{plength}</button>
                </li>
            );
        }

        if (currentPage < totalPages - 1) {
            if (currentPage < totalPages - 2) {
                liTag.push(
                    <li className="page-item disabled" key="dots2">
                        <span className="page-link">...</span>
                    </li>
                );
            }
            liTag.push(
                <li
                    className="page-item"
                    key="last"
                    onClick={() => paginate(totalPages)}
                >
                    <button className="page-link">{totalPages}</button>
                </li>
            );
        }

        if (currentPage < totalPages) {
            liTag.push(
                <li className="page-item" key="next">
                    <button
                        className="page-link"
                        onClick={() => paginate(currentPage + 1)}
                    >
                        Next <FaAngleRight />
                    </button>
                </li>
            );
        }

        return liTag;
    };

    // ================================================================

    const [rolename, setrolename] = useState([]);
    useEffect(() => {

        const branchName = localStorage.getItem("branch_name");
        setrolename(branchName);
    }, []);


    const [loading, setLoading] = useState(false)



    const data = useMemo(() => {
        return responseData.map((item) => ({
            _id: item._id,
            branch_id: item.branch_id ? {
                _id: item.branch_id._id,
                branch_name: item.branch_id.branch_name,
            } : {
                _id: null,
                branch_name: "N/A"
            },
            category: item.category || "",
            FacultyName: item.FacultyName || "",
            Designation: item.Designation || "",
            official_email: item.official_email || "",
            website: item.website || "",
            location: item.location || "",
            remark: item.remark || "",
            staffid_name: item.staffid_name || "",
            status: item.status || "",
            __v: item.__v,
        }));
    }, [responseData]);

    const columns = useMemo(
        () => [
            {
                Header: "S.No",
                id: "serialNo",
                Cell: ({ row }) => {
                    return row.index + 1; // Displaying serial number (1-based)
                },
            },
            {
                Header: "Branch",
                accessor: "branch_id.branch_name", // The key here is branch_id
                Filter: DefaultColumnFilter,
                filter: "multiSelectFilter",
                // Custom cell rendering to display the branch name
                // Cell: ({ value }) => value?.branch_name || "N/A", // Safely accessing branch_name
            },
            {
                Header: "Category",
                accessor: "category",
                Filter: DefaultColumnFilter,
                filter: "multiSelectFilter",
            },
            {
                Header: "FacultyName",
                accessor: "FacultyName",
                Filter: DefaultColumnFilter,
                filter: "multiSelectFilter",
            },
            {
                Header: "Designation",
                accessor: "Designation",
                Filter: DefaultColumnFilter,
                filter: "multiSelectFilter",
            },
            {
                Header: "Official Email",
                accessor: "official_email",
                Filter: DefaultColumnFilter,
                filter: "multiSelectFilter",
            },
            {
                Header: "Website",
                accessor: "website",
                Filter: DefaultColumnFilter,
                filter: "multiSelectFilter",
            },
        ],
        []
    );


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        state,
        setGlobalFilter,
        setPageSize,
        page,
        canPreviousPage,
        canNextPage,
        pageCount,
        gotoPage,
    } = useTable(
        {
            columns,
            data,
            initialState: { pageSize: 10 },
            defaultColumn: { Filter: DefaultColumnFilter },
            filterTypes: {
                multiSelectFilter: (rows, columnIds, filterValue) => {
                    if (!filterValue || filterValue.length === 0) {
                        return rows;
                    }
                    return rows.filter((row) => {
                        const rowValue = row.values[columnIds[0]];
                        const rowValueStr = String(rowValue);
                        return filterValue.some((filterVal) =>
                            rowValueStr.includes(String(filterVal))
                        );
                    });
                },
            },
        },
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination
    );




    return (
        <>

            {loading === true ? (
                <div className="loading-overlay">
                    <div className="loading-message">
                        <img
                            className="loadinggif"
                            src={require("../../assets/img/output-onlinegiftools.gif")}
                        />{" "}
                    </div>
                </div>
            ) : (
                <div className="d-none"></div>
            )}

            <div className='top'>
                <div className="" style={{ marginTop: '-80px' }}>
                    <div className="row mb-3">
                        <div className="col-lg-11">
                            <Link to="/dashboard" className="text-secondary dashBoard_text">
                                <b>Dashboard / </b>
                            </Link>
                            <Link to="/assetlist" className="text-secondary dashBoard_text">
                                <b>Jobportal / </b>
                            </Link>
                            <Link to="" className="text-danger dashBoard_text">
                                <b>Recruting</b>
                            </Link>
                        </div>
                    </div>
                </div>
                {/* Table */}


                {/* ------------ search and per page ----------------------------*/}

                {/* <div className="mb-3 mt-3">
                    <div className="row">
                        <div className="col-lg-2 col-md-4 col-sm-4 d-flex">
                            <label className='form-label text-dark mt-2'>Show : </label>
                            <div>
                                <select className="form-control w-100 mx-2" onChange={(e) => { setItemsPerPage(e.target.value) }}>
                            
                                    <option value='10'>10</option>
                                    <option value='20'>20</option>
                                    <option value='50'>50</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-7 col-md-4 col-sm-1"></div>
                        <div className="col-lg-3 col-md-4 col-sm-7">

                            <div className="w-full flex-1">
                                <form>
                                    <div className="relative">

                                        <input
                                            className="form-control w-full bg-white  appearance-none pl-8  dark:bg-gray-950"
                                            placeholder="Search ..."
                                            type="search"
                                            value={searchQuery}
                                            onChange={handleSearchChange}
                                        />

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div> */}


                <div className="mb-1 mt-3">
                    <div className="row">
                        <div className="col-lg-7 col-md-4 col-sm-1">
                            <div className='d-flex'>
                                <h5 className='mt-1'>Recruiting</h5>
                                <div className='mx-3'>
                                    {previllages.add && (
                                        <button className='btn add' onClick={() => setShowModal(true)}>Add</button>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-4 col-sm-4 d-flex justify-content-end">

                            {/* </div>

                        <div className="col-lg-3 col-md-4 col-sm-7"> */}
                            <div className="w-full flex-1 me-5">
                                <form>
                                    <div className="relative">
                                        <input
                                            className="form-control w-full bg-white appearance-none pl-8 dark:bg-gray-950"
                                            placeholder="Search ..."
                                            type="search"
                                            value={state.globalFilter || ""} // Use the globalFilter value
                                            onChange={(e) => setGlobalFilter(e.target.value)} // Update global filter
                                        />
                                    </div>
                                </form>
                            </div>
                            <div className='d-flex me-2'>
                                <label className="form-label text-dark mt-1">Show : </label>
                                <div>
                                    <select
                                        className="form-control w-100 mx-2"
                                        value={state.pageSize}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === 'All') {
                                                setPageSize(data.length);  // 'data' should be your dataset containing all the entries
                                            } else {
                                                setPageSize(Number(value));
                                            }
                                        }}
                                    >
                                        <option value="All">All</option> {/* Add 'All' option */}
                                        {[10, 20, 100, 200, 500, 1000].map((pageSize) => (
                                            <option key={pageSize} value={pageSize}>
                                                {pageSize}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                {/* --------------------------------end------------------------------------------- */}
                {/* <div className='card'>
                    <div className="mt-1">
                        <table className="table table-striped">
                            <thead>
                                <tr>


                                    <th>S.No</th>
                                    <td> {rolename === "Branches" && <th>Branch</th>}</td>
                                    <th>Category</th>
                                    <th>FacultyName</th>
                                    <th>Designation</th>
                                    <th>Official Email</th>
                                    <th>Website</th>
                                    <th className='text-center'>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td> {rolename === "Branches" && item.branch_id?.branch_name}</td>
                                    
                                        <td>{item.category}</td>
                                        <td>{item.FacultyName}</td>
                                        <td>{item.Designation}</td>
                                        <td>{item.official_email}</td>
                                        <td>{item.website}</td>
                                        <td className='text-center'>
                                            {previllages.edit && (
                                                <button className='btn updelete mx-2' onClick={() => handleUpdate(item._id, item)}><i class="fa-solid fa-pen-to-square"></i></button>)}
                                            {previllages.delete && (<button className='btn delete'
                                                onClick={() => handleOpenModal(item._id, item.category)}
                                            > <i class="fa-solid fa-trash-can"></i></button>)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div> */}




                <Table {...getTableProps()}>
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <Th
                                        {...column.getHeaderProps(column.getSortByToggleProps())}
                                    >
                                        <div className="d-flex">
                                            <div className="mx-2">{column.render("Header")}</div>
                                            <div>
                                                {column.canFilter ? column.render("Filter") : null}
                                            </div>
                                            <div className="mx-1">
                                                {column.isSorted
                                                    ? column.isSortedDesc
                                                        ? " 🔽"
                                                        : " 🔼"
                                                    : ""}
                                            </div>
                                        </div>
                                    </Th>
                                ))}
                                <Th className="text-center">Action</Th>
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map((cell) => (
                                        <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                                    ))}
                                    <Td className="text-center">
                                        <ActionsDropdown
                                            row={row.original}
                                            permissions={{
                                                edit: previllages.edit,
                                                delete: previllages.delete,
                                            }}
                                            onEdit={(id, row) =>
                                                handleUpdate(id, row)
                                            }
                                            onDelete={(id, row) =>
                                                handleOpenModal(id, row.FacultyName)
                                            }
                                        />
                                    </Td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>



                {/* Modal for adding a new user */}
                <Modal show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title id="modeti">Add Recruiting </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>



                        <div className='row'>
                            <div className='col-lg-6'>
                                <div className="form-group">
                                    <div className="floating-label">
                                        <label className="form-label">
                                            <b></b>
                                        </label>
                                        <select className="form-select" value={addData.branch_id} placeholder=''

                                            onChange={(e) => setAddData({ ...addData, branch_id: e.target.value })}
                                        >
                                            <option value="">Select Brand</option>
                                            {branch.map((item, index) => (
                                                <option key={index} value={item._id}>
                                                    {item.branch_id} - {item.branch_name}
                                                </option>
                                            ))}
                                        </select>

                                        <label className={addData.branch_id ? "filled" : ""}>
                                            Select Branch
                                        </label>

                                    </div>


                                    {/* <div className="floating-label">
                                    <input className="form-control" placeholder='' type="text" value={addData.category} onChange={(e) => setAddData({ ...addData, category: e.target.value })} required />
                                    <label className={addData.category ? "filled" : ""}>
                                        Category
                                    </label>
                                </div> */}

                                    <div className="floating-label">
                                        <select className="form-control" value={addData.category} onChange={(e) => setAddData({ ...addData, category: e.target.value })}>
                                            <option value="">Select Category</option>
                                            <option value="Digital Marketing">Digital Marketing</option>
                                            <option value="Industrial Automation">Industrial Automation</option>
                                            <option value="Others">Others</option>
                                        </select>
                                        <label className={addData.category ? "filled" : ""}>
                                            Select Category
                                        </label>
                                    </div>


                                    <div className="floating-label">
                                        <input className="form-control" placeholder='' type="text" value={addData.FacultyName} onChange={(e) => setAddData({ ...addData, FacultyName: e.target.value })} required />
                                        <label className={addData.FacultyName ? "filled" : ""}>
                                            FacultyName
                                        </label>



                                    </div>



                                    <div className="floating-label">
                                        <input className="form-control" placeholder='' type="text" value={addData.Designation} onChange={(e) => setAddData({ ...addData, Designation: e.target.value })} required />
                                        <label className={addData.Designation ? "filled" : ""}>
                                            Designation
                                        </label>



                                    </div>


                                    <div className="floating-label">
                                        <input className="form-control" placeholder='' type="text" value={addData.official_email} onChange={(e) => setAddData({ ...addData, official_email: e.target.value })} required />
                                        <label className={addData.official_email ? "filled" : ""}>
                                            Official Email
                                        </label>



                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6'>
                                <div className="form-group">



                                    <div className="floating-label">
                                        <input className="form-control" placeholder='' type="text" value={addData.website} onChange={(e) => setAddData({ ...addData, website: e.target.value })} required />
                                        <label className={addData.website ? "filled" : ""}>
                                            Website
                                        </label>



                                    </div>


                                    <div className="floating-label">
                                        <input className="form-control" placeholder='' type="text" value={addData.location} onChange={(e) => setAddData({ ...addData, location: e.target.value })} required />
                                        <label className={addData.location ? "filled" : ""}>
                                            Location
                                        </label>
                                    </div>
                                    <div className="floating-label">
                                        <input className="form-control" placeholder='' type="text" value={idlocal || ""} onChange={(e) =>
                                            setAddData({ ...addData, idlocal: e.target.value })
                                        } required />
                                        <label className={idlocal ? "filled" : ""}>StaffId Name</label>


                                    </div>


                                    <div className="floating-label">
                                        <select className="form-control" value={addData.status} onChange={(e) => setAddData({ ...addData, status: e.target.value })}>
                                            <option value="">Select Status</option>
                                            <option value="Active">Active</option>
                                            <option value="InActive">InActive</option>

                                        </select>
                                        <label className={addData.status ? "filled" : ""}>
                                            Select Status
                                        </label>

                                    </div>

                                </div>
                            </div>
                            <div className="floating-label col-lg-12">
                                <input className="form-control" placeholder='' type="text" value={addData.remark} onChange={(e) => setAddData({ ...addData, remark: e.target.value })} required />
                                <label className={addData.remark ? "filled" : ""}>
                                    Remark
                                </label>
                            </div>
                        </div>



                    </Modal.Body>

                    <Modal.Footer>
                        <Button className='cancelbut' variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
                        <Button className='submitbut' variant="primary" onClick={handlesubmit}>Submit</Button>
                    </Modal.Footer>
                </Modal>


                <Modal show={isUpdateshowModal} onHide={() => setUpdateShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title id="modeti">Update Recruiting</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='row'>
                            <div className='col-lg-6'>
                                <div className="form-group">
                                    <div className="floating-label">
                                        <select className="form-select" value={updateData.branch_id} onChange={(e) => setUpdateData({ ...updateData, branch_id: e.target.value })}>
                                            <option value="" disabled>Select Branch </option>
                                            {branch.map((item, index) => (
                                                <option key={index} value={item._id}>
                                                    {item.branch_id} - {item.branch_name}
                                                </option>
                                            ))}
                                        </select>
                                        <label className={updateData.branch_id ? "filled" : ""}>

                                        </label>

                                    </div>



                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.category} onChange={(e) => setUpdateData({ ...updateData, category: e.target.value })} required />
                                        <label className={updateData.category ? "filled" : ""}>
                                            Category
                                        </label>
                                    </div>



                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.FacultyName} onChange={(e) => setUpdateData({ ...updateData, FacultyName: e.target.value })} required />
                                        <label className={updateData.FacultyName ? "filled" : ""}>
                                            FacultyName
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.Designation} onChange={(e) => setUpdateData({ ...updateData, Designation: e.target.value })} required />
                                        <label className={updateData.Designation ? "filled" : ""}>
                                            Designation
                                        </label>
                                    </div>



                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.official_email} onChange={(e) => setUpdateData({ ...updateData, official_email: e.target.value })} required />
                                        <label className={updateData.official_email ? "filled" : ""}>
                                            Official Email
                                        </label>
                                    </div>


                                </div>
                            </div>
                            <div className='col-lg-6'>


                                <div className="floating-label">
                                    <input className="form-control" type="text" placeholder='' value={updateData.website} onChange={(e) => setUpdateData({ ...updateData, website: e.target.value })} required />
                                    <label className={updateData.website ? "filled" : ""}>
                                        Website
                                    </label>
                                </div>

                                <div className="floating-label">
                                    <input className="form-control" type="text" placeholder='' value={updateData.location} onChange={(e) => setUpdateData({ ...updateData, location: e.target.value })} required />
                                    <label className={updateData.location ? "filled" : ""}>
                                        Location
                                    </label>
                                </div>
                                <div className="floating-label">
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        value={idlocal}
                                        onChange={(e) =>
                                            setUpdateData({
                                                ...updateData,
                                                idlocal: e.target.value,
                                            })
                                        }
                                        disabled
                                        required
                                    />
                                    <label className={idlocal ? "filled" : ""}>   StaffId Name</label>
                                </div>


                                <div className="floating-label">
                                    <select className="form-control" value={updateData.status} onChange={(e) => setUpdateData({ ...updateData, status: e.target.value })}>
                                        <option value="">Select Status</option>
                                        <option value="Active">Active</option>
                                        <option value="InActive">InActive</option>

                                    </select>
                                    <label className={updateData.status ? "filled" : ""}>
                                        Select Status
                                    </label>
                                </div>
                            </div>
                            <div className="floating-label col=lg-12">
                                <input className="form-control" type="text" placeholder='' value={updateData.remark} onChange={(e) => setUpdateData({ ...updateData, remark: e.target.value })} required />
                                <label className={updateData.remark ? "filled" : ""}>
                                    Remark
                                </label>
                            </div>
                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button className='cancelbut' variant="secondary" onClick={() => setUpdateShowModal(false)}>Cancel</Button>
                        <Button className='submitbut' variant="primary" onClick={handleupdatesubmit}>Update</Button>
                    </Modal.Footer>
                </Modal>





                {/* ----------------delete */}

                <Modal className="modal" show={deleteShowModalss} onHide={handleCloseModal}>
                    <Modal.Header>
                        <p id="modeti">Are you sure you want to Delete?</p>
                    </Modal.Header>
                    <Modal.Body>


                        <label className="form-label d-flex">
                            <h5 className='mx-1'>FacultyName :</h5> <h5>{getdeletename} </h5>
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className='cancelbut' variant="secondary" onClick={handleCloseModal}>
                            Close
                        </Button>
                        <Button className='submitbut' variant="primary" onClick={handleDelete} >Delete</Button>
                    </Modal.Footer>
                </Modal>
                {/* _------------------------------pagination button -------------------------------- */}



                <div className="mt-3 pb-5">
                    <div className="row">
                        <div className="col-lg-7 col-sm-12 mt-1">
                            <span className="text-dark">
                                Page {currentPage} of {totalPages}
                            </span>
                        </div>
                        <div className="col-lg-5">
                            <nav>
                                <ul className="pagination justify-content-center">
                                    {createPagination()}
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>


                {/* ---------------------------------------end ---------------------------------- */}


            </div>
        </>
    )
}

export default Recruiting_partner

